module.exports = __webpack_public_path__ + "img/home-bg.4e32084f.png";